import { OvTableData } from '../../../components/UI/molecules/OvTable';
import { StrawStageApiResponse } from '../../model/dto/straw-stage/straw-stage-api-response';

export class StrawStageDataUtils {
  static mapStrawStageDataToTableData(
    data?: StrawStageApiResponse
  ): OvTableData {
    return [
      {
        label: 'strawStage.fields.strawStage',
        translateLabel: true,
        value: data?.straw_stage ?? '-',
      },
      {
        label: 'strawStage.fields.cluster',
        translateLabel: true,
        value: data?.cluster ?? '-',
      },
      {
        label: 'strawStage.fields.name',
        translateLabel: true,
        value: data?.name ?? '-',
      },
      {
        label: 'strawStage.fields.description',
        translateLabel: true,
        value: data?.description ?? '-',
        displayAsHTML: true,
      },
      {
        label: 'strawStage.fields.predictedPhaseLength',
        translateLabel: true,
        value: data?.predicted_phase_length ?? '-',
      },
    ];
  }
}
